<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="breadcrumbList"
      :btns="isEdit ? [
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'submit',
          text: '提交',
          type: 'primary'
        }
      ]:[]"
      @btn-click="onBtnClick"
    >
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>收货单编码：{{purchaseReceipt.code}}</h4>
            <div>收货员：{{purchaseReceipt.createUserName}}</div>
            <div>创建时间：{{purchaseReceipt.createTime}}</div>
            <!-- <div>仓库：{{purchaseReceipt.supplierInventory}}</div> -->
            <div>运输方式：{{purchaseReceipt.transportMode}}</div>
            <div v-if="purchaseReceipt.transportModeId === 4">承运方式：{{purchaseReceipt.carryModeName}}</div>
            <div v-if="purchaseReceipt.transportModeId === 4">承运单位：{{purchaseReceipt.carrier}}</div>
            <div>车牌号：{{purchaseReceipt.licensePlate}}</div>
            <div>起运时间：{{purchaseReceipt.transTimeStart}}</div>
            <div>到货时间：{{purchaseReceipt.transTimeEnd}}</div>
            <div>随货同行单：{{purchaseReceipt.travelNo}}</div>
          </div>
          <div class="info-item">
            <h4>采购订单号：{{purchaseOrder.code}}</h4>
            <div>创建时间：{{purchaseOrder.createTime}}</div>
            <div>供应商：{{purchaseOrder.supplierName}}</div>
            <div>成本类型：{{purchaseOrder.paymentName}}</div>
          </div>
          <div class="info-item">
            <h4>采购计划单号：{{purchasePlan.code}}</h4>
            <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
            <div>来源：{{purchasePlan.typeName}}</div>
            <div>采购人：{{purchasePlan.createUserName}}</div>
            <div>创建时间：{{purchasePlan.createTime}}</div>
          </div>
        </div>
      </div>
      <div slot="content">
        <ApprovalFlow :workNo="workNo" class="steps-wrap" :finishHide="true"/>
        <lk-card title="商品详情">
          <div class="sum-wrap">
            <div class="title-amount">总商品数量</div>
            <div class="content-amount">{{receiptGoodsNum}}</div>
            <div class="title-money">总金额（元）</div>
            <div class="content-money">&yen;{{receiptAmount}}</div>
          </div>
          <lk-table border :columns='columns' :data='tableData'></lk-table>
        </lk-card>
        <lk-card title="其他信息"  class="other-card">
          <lk-form :label-width='130' label-position="right">
            <lk-row class="reject-row" :gutter='16'>
              <lk-col span="24">
                <lk-form-item label="拒收商品:">
                  <lk-table border :data="rejectData" :columns="rejectColumn" class="rejectTable"/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row v-for="(item, index) in purchaseReceiptImgInfoList" :key="index" :gutter='16'>
              <lk-col span="10">
                <lk-form-item label="温度附件图:">
                  <Uploader  v-model="item.temperatureImg"></Uploader>
                </lk-form-item>
              </lk-col>
              <lk-col span="2"></lk-col>
              <lk-col span="10">
                <lk-form-item label="温度图备注:">
                  <span>{{item.imgComment}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>

          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>

<script>

import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';
import ApprovalFlow from '../../components/ApprovalFlow';

export default {
  name: 'receiptInfo',
  components: {
    BaseFrame, Uploader, ApprovalFlow,
  },
  data() {
    return {
      receiptGoodsNum: '',
      receiptAmount: '',
      workNo: '',
      rejectData: [],
      rejectColumn: [
        {
          title: '通用名称',
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '产地',
          key: 'purchaseMedicineCountryOfOrigin',
        },
        {
          title: '商品编码',
          key: 'purchaseMedicineDrugSerialCode',
        },
        {
          title: '规格',
          key: 'medicineInfoVoSpecifications',
        },
        {
          title: '医保编码',
          width: 200,
          tooltip: true,
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '生产厂家',
          key: 'medicineInfoVoManufacturer',
        },
        {
          title: '上市许可持有人',
          key: 'medicineInfoVoMah',
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'medicineInfoVoDosageFormString',
        },
        {
          title: '拒收数量',
          key: 'purchaseReceiptInfoRejectNum',
        },
        {
          title: '拒收原因',
          key: 'purchaseReceiptInfoRejectReason',
        },
      ],
      purchaseReceiptImgInfoList: [],
      paymentType: ['普通', '寄售'],
      queryParams: {
        purchaseReceiptId: '',
      },
      purchasePlan: {
        code: '',
        goodsType: null,
      },
      purchaseOrder: {
        code: '',
        createUserName: '',
      },

      purchaseReceipt: {
        code: '',
        status: '',
        createUserName: '',
        createTime: '',
        transTimeStart: '',
        transTimeEnd: '',
      },
      columns: [
        {
          title: '行号',
          minWidth: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          tooltip: true,
          key: 'medicineInfoVoApprovedDrugNames',
          minWidth: 142,
        },
        {
          title: '产地',
          minWidth: 142,
          tooltip: true,
          key: 'purchaseMedicineCountryOfOrigin',
        },
        {
          title: '商品编码',
          tooltip: true,
          key: 'purchaseMedicineDrugSerialCode',
          minWidth: 82,
        },
        {
          title: '批准文号',
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
          minWidth: 116,
        },
        {
          title: '规格',
          tooltip: true,
          key: 'medicineInfoVoSpecifications',
          minWidth: 130,
        },
        {
          title: '医保编码',
          width: 200,
          tooltip: true,
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '生产企业',
          key: 'medicineInfoVoManufacturer',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMah',
        },
        {
          title: '储存条件',
          minWidth: 112,
          tooltip: true,
          key: 'medicineInfoVoStorageConditions',
        },
        {
          title: '商品名称',
          tooltip: true,
          key: 'medicineInfoVoGoodsName',
          minWidth: 142,
        },
        {
          title: '计划数量',
          key: 'purchaseMedicineNum',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '计划单价',
          key: 'purchaseMedicinePlanPrice',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '实际收货数量',
          key: 'purchaseReceiptInfoAcceptNum',
          tooltip: true,
          minWidth: 106,
        },
        {
          title: '实际含税单价',
          key: 'purchaseReceiptInfoPriceBeforeTax',
          tooltip: true,
          minWidth: 106,
        },
        {
          title: '批号',
          key: 'purchaseReceiptInfoGoodsBatchNum',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '生产日期',
          key: 'purchaseReceiptInfoProductionDate',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '有效日期',
          key: 'purchaseReceiptInfoExpiryDate',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '进项税率(%)',
          key: 'purchaseReceiptInfoTaxRate',
          tooltip: true,
          minWidth: 102,
        },
        {
          title: '税额',
          key: 'purchaseReceiptInfoTax',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '不含税总额',
          key: 'purchaseReceiptInfoTotalAmountWithoutTax',
          tooltip: true,
          minWidth: 112,
        },
        {
          title: '检验报告',
          key: 'purchaseReceiptInfoReportUrl',
          minWidth: 230,
          render: (h, { row, index }) => h(Uploader, {
            props: {
              url: row.purchaseReceiptInfoReportUrl,
              maxSize: 20,
              able: this.isEdit,
              format: ['jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'rar', 'zip', '7z', 'tar', 'gz'],
            },
            on: {
              handle: (val) => {
                this.tableData[index].purchaseReceiptInfoReportUrl = val || '';
              },
            },
          }),
        },
        {
          title: '起点温度',
          key: 'purchaseReceiptInfoStartTemperature',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '到店温度',
          key: 'purchaseReceiptInfoEndTemperature',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '拒收数量',
          key: 'purchaseReceiptInfoRejectNum',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '拒收原因',
          key: 'purchaseReceiptInfoRejectReason',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '剂型',
          key: 'medicineInfoVoDosageFormString',
          tooltip: true,
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'purchaseMedicineDrugMinimumPackagingUnit',
          tooltip: true,
          minWidth: 62,
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,

      localtion: [],
      type: ['审核', '废弃', '完成', '完成验收'],
    };
  },
  computed: {
    breadcrumbList() {
      const breadcrumb = [{
        name: 'receipt',
        title: '收货单',
      }];
      if (this.$route.name === 'receiptInfo') {
        breadcrumb.push({
          name: 'receiptInfo',
          title: '收货单详情',
        });
      } else {
        breadcrumb.push({
          name: 'receiptEdit',
          title: '收货单编辑',
        });
      }
      return breadcrumb;
    },
    isEdit() {
      return this.$route.name === 'receiptEdit';
    },
  },
  methods: {

    getlocaltions() {

    },
    loadLocaltion() {

    },
    getData() {
      this.queryParams.purchaseReceiptId = this.$route.params.purchaseReceiptId;
      const queryParams = Object.assign({}, this.queryParams);
      // console.log(queryParams);

      purchase.receiptInfo(queryParams).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.receiptAmount = res.data.data.receiptAmount || '0.00';
          this.receiptGoodsNum = res.data.data.receiptGoodsNum;
          if (res.data.data.purchaseReceipt) {
            this.purchaseReceipt.createTime = utils.formatTime(res.data.data.purchaseReceipt.createTime, 'YYYY/MM/DD HH:mm');
            this.purchaseReceipt.createUserName = res.data.data.purchaseReceipt.createUserName;
            this.purchaseReceipt.code = res.data.data.purchaseReceipt.code;
            this.purchaseReceipt.supplierInventory = res.data.data.purchaseReceipt.supplierInventory;
            this.purchaseReceipt.transportMode = res.data.data.purchaseReceipt.transportMode;
            this.purchaseReceipt.transportModeId = res.data.data.purchaseReceipt.transportModeId;
            this.purchaseReceipt.carryModeName = res.data.data.purchaseReceipt.carryModeName;
            this.purchaseReceipt.carrier = res.data.data.purchaseReceipt.carrier;
            this.purchaseReceipt.travelNo = res.data.data.purchaseReceipt.travelNo;
            this.purchaseReceipt.licensePlate = res.data.data.purchaseReceipt.licensePlate;
            if (res.data.data.purchaseReceipt.transTimeStart) {
              this.purchaseReceipt.transTimeStart = utils.formatTime(res.data.data.purchaseReceipt.transTimeStart, 'YYYY/MM/DD HH:mm');
            }
            if (res.data.data.purchaseReceipt.transTimeEnd) {
              this.purchaseReceipt.transTimeEnd = utils.formatTime(res.data.data.purchaseReceipt.transTimeEnd, 'YYYY/MM/DD HH:mm');
            }
          }
          if (res.data.data.purchaseOrder) {
            this.purchaseOrder.code = res.data.data.purchaseOrder.code;
            this.purchaseOrder.supplierName = res.data.data.purchaseOrder.supplierName;
            this.purchaseOrder.paymentName = this.paymentType[res.data.data.purchaseOrder.payment - 1];
            this.purchaseOrder.createTime = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD HH:mm');
          }
          if (res.data.data.purchasePlan) {
            this.purchasePlan.code = res.data.data.purchasePlan.code;
            this.purchasePlan.createUserName = res.data.data.purchasePlan.createUserName;
            this.purchasePlan.createTime = utils.formatTime(res.data.data.purchasePlan.createTime, 'YYYY/MM/DD HH:mm');
            this.purchasePlan.goodsTypeName = res.data.data.purchasePlan.goodsTypeName;
            this.purchasePlan.goodsType = res.data.data.purchasePlan.goodsType;
            this.purchasePlan.typeName = res.data.data.purchasePlan.typeName;
          }

          res.data.data.purchaseMedicineInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseReceiptInfoExpiryDate = utils.formatTime(result.purchaseReceiptInfoExpiryDate, 'YYYY/MM/DD');
            result.purchaseReceiptInfoProductionDate = utils.formatTime(result.purchaseReceiptInfoProductionDate, 'YYYY/MM/DD');
            console.log(result);
            this.tableData.push(result);
          });
          if (res.data.data.purchaseReceiptImgInfoList) {
            this.purchaseReceiptImgInfoList = res.data.data.purchaseReceiptImgInfoList;
          }
          res.data.data.purchaseRejectionInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.rejectData.push(result);
          });
          if (res.data.data.purchaseReceipt && res.data.data.purchaseReceipt.workNo) {
            this.workNo = res.data.data.purchaseReceipt.workNo;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
    handleToList() {
      this.$router.push({
        name: 'receipt',
      });
    },
    onBtnClick(name) {
      if (name === 'cancel') {
        this.handleToList();
      } else if (name === 'submit') {
        this.submit();
      }
    },
    submit() {
      const purchaseMedicineInfoVoList = [];
      const purchaseReceipt = { ...this.purchaseReceipt };
      const purchaseReceiptImgInfoList = [];

      purchaseReceipt.createTime = utils.toTimestamp(purchaseReceipt.createTime);
      purchaseReceipt.transTimeStart = utils.toTimestamp(purchaseReceipt.transTimeStart);
      purchaseReceipt.transTimeEnd = utils.toTimestamp(purchaseReceipt.transTimeEnd);

      const purchaseOrder = {
        id: this.queryParams.purchaseReceiptId,
      };
      this.tableData.forEach((item) => {
        const purchaseMedicine = {
          id: item.purchaseMedicineId,
          comment: item.purchaseMedicineComment,
          medicineId: item.purchaseMedicineMedicineId,
        };
        item.rejectNum = 0;
        item.rejectReason = '';
        this.rejectData.forEach((rejectItem) => {
          if (rejectItem.purchaseMedicineMedicineId === item.purchaseMedicineMedicineId) {
            item.rejectNum = rejectItem.rejectNum;
            item.rejectReason = rejectItem.rejectReason;
          }
        });
        const purchaseReceiptInfo = {
          id: item.purchaseReceiptInfoId,
          priceBeforeTax: item.purchaseReceiptInfoPriceBeforeTax,
          acceptNum: Number(item.purchaseReceiptInfoAcceptNum),
          goodsBatchNum: item.purchaseReceiptInfoGoodsBatchNum ? item.purchaseReceiptInfoGoodsBatchNum : '',
          productionDate: utils.toTimestamp(item.purchaseReceiptInfoProductionDate),
          expiryDate: utils.toTimestamp(item.purchaseReceiptInfoExpiryDate),
          reportUrl: item.purchaseReceiptInfoReportUrl,
          taxRate: item.purchaseReceiptInfoTaxRate,
          finishReceipt: item.finishReceipt ? 1 : 2,
          rejectNum: Number(item.rejectNum) ? Number(item.rejectNum) : 0,
          rejectReason: item.rejectReason ? item.rejectReason : '',
        };
        const TodoReceiptNum = item.purchaseMedicineTodoReceiptNum;
        const acceptNum = purchaseReceiptInfo.acceptNum;
        const rejectNum = purchaseReceiptInfo.rejectNum;
        if ((acceptNum + rejectNum) === TodoReceiptNum) {
          purchaseReceiptInfo.finishReceipt = 1;
        }
        purchaseMedicineInfoVoList.push({
          purchaseMedicine, purchaseReceiptInfo,
        });
      });

      this.purchaseReceiptImgInfoList.forEach((item) => {
        if (item.temperatureImg) {
          purchaseReceiptImgInfoList.push(item);
        }
      });


      const data = {
        purchaseOrder,
        purchaseMedicineInfoVoList,
        purchaseReceiptImgInfoList,
        purchaseReceipt,
      };
      purchase.receiptUpdateReportUrl(data).then((res) => {
        const code = res.data.status;
        if (code === 200) {
          this.$Message.success('提交成功');
          this.handleToList();
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
  },
  watch: {
    'purchasePlan.goodsType': function goodsTypeHandler() {
      if (this.purchasePlan.goodsType === 2) {
        this.columns.splice(4, 1, {
          title: '注册证号/备案号',
          minWidth: 124,
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
        });
      } else {
        this.columns.splice(4, 1, {
          title: '批准文号',
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
          minWidth: 116,
        });
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.other-card{
  margin-top: 30px;
}
.reject-row{
  margin-bottom: 40px;
}
.steps-wrap{
  padding-top: 30px;
  padding-bottom: 30px;
}
.reject-table{
  display: flex;
  .reject-title{
    width: 130px;
    text-align: right;
  }
}
</style>
